// extracted by mini-css-extract-plugin
export default {"popover":"CCAPopover-module__popover--uEfBa","popover_content":"CCAPopover-module__popover_content--_I5lh"};